export default __webpack_public_path__ + "c000d74cf343a248df64cba802441e53.svg";